import { XIcon } from 'lucide-react';
import { getPublicFilterDisplayValue } from './get-public-filter-display-value';
import type { PublicFilterValue } from './public-filter-menu';

type Props = PublicFilterValue & {
  onRemove: (value: PublicFilterValue) => void;
};

export const PublicFilterItem = (props: Props) => {
  const { filterType, value, onRemove } = props;
  const { label, Icon } = getPublicFilterDisplayValue(filterType, value);

  return (
    <div className="bg-muted flex items-center gap-2 rounded-sm px-2 py-1.5 text-sm">
      {Icon && <Icon className="size-4" />}
      {label}
      <button className="cursor-pointer" onClick={() => onRemove(props)}>
        <XIcon className="size-4" />
      </button>
    </div>
  );
};
